// @material-ui/core
import { IconButton, Menu, MenuItem } from "@material-ui/core";
// @material-ui/icons
import { MoreVert as MoreVertIcon } from "@material-ui/icons";
import React, { Component } from "react";
import { NavLink } from "react-router-dom";

const ITEM_HEIGHT = 48;

export class ItemCardMenu extends Component {
  render() {
    let { classes, open } = this.props;
    return (
      <span>
        <IconButton
          aria-label="More"
          aria-owns={open ? "long-menu" : null}
          aria-haspopup="true"
          onClick={this.handleClick}>
          <MoreVertIcon />
        </IconButton>
        <Menu
          id="long-menu"
          anchorEl={this.state.anchorEl}
          open={open}
          onRequestClose={this.handleRequestClose}
          PaperProps={{
            style: { maxHeight: ITEM_HEIGHT * 4.5, width: 200 }
          }}>
          {this.props.options.map((option, index) => (
            <NavLink
              to={option.link}
              activeClassName="active"
              key={index}
              className={classes.navLink}>
              <MenuItem onClick={this.handleRequestClose}>
                {option.title}
              </MenuItem>
            </NavLink>
          ))}
        </Menu>
      </span>
    );
  }
}



// WEBPACK FOOTER //
// ./src/library/card/item-card/menu.js